import { useState } from "react";
import api from "../Api";

export function useForgotPassword() {
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");
    const [error, setError] = useState("");

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await api.post("/users/request-password-reset", { email });
            setMessage("Er is een e-mail verzonden met instructies om je wachtwoord te resetten.");
            setError("");
        } catch (err) {
            setError("Kon geen resetlink versturen. Controleer het e-mailadres.");
            setMessage("");
        }
    };

    return {
        email,
        setEmail,
        message,
        error,
        handleSubmit,
    };
}

